import { NetworkCriteriaType } from 'components/common/types/DirectSalesNetworks.types';
import { SectionSelectedType } from 'lib/SectionButton/SectionButton.types';
import { getNoRestrictionsDisplayValue } from '../../utils/getNoRestrictionsDisplayValue';
import { isValueRequired } from '../../utils/isValueRequired';
import { NetworkRangeValue } from './ProductNetwork.types';

export const getNetworkRangeValues = (selectedNetworks: NetworkCriteriaType[]): NetworkRangeValue => {
  if (!selectedNetworks.length) return {};

  return selectedNetworks.reduce<NetworkRangeValue>((acc, { name, defaultValue, minValue, maxValue }) => {
    const ranges: Record<string, string> = {};

    if (defaultValue !== undefined) {
      ranges.Default = defaultValue.toString();
    }

    if (minValue !== undefined) {
      ranges.Minimum = minValue.toString();
    }

    if (maxValue !== undefined) {
      ranges.Maximum = maxValue.toString();
    }

    acc[name] = ranges;

    return acc;
  }, {});
};

export const getSelectedNetworkDisplayValue = (
  categorizedValues: SectionSelectedType,
  networkSelectedPermission?: string,
): SectionSelectedType | undefined => {
  if (!networkSelectedPermission) {
    return undefined;
  }

  if (isValueRequired(networkSelectedPermission)) {
    return categorizedValues;
  }

  return getNoRestrictionsDisplayValue(networkSelectedPermission);
};
